import React, { useEffect, useState } from "react";
import "./feedbackPage.css";
// import API_Root from "../../Constants/API_Root";
import API_Root from "../../../../Constants/API_Root";
// import { authFetch } from "../../Authentication/authService";
import { authFetch } from "../../../../Authentication/authService";

const FEEDBACK_FORM_URL =
  `https://alpha.essolutions.ai/feedback-form`; // <-- Replace with actual URL

const FeedbackPage = () => {
  const [feedbackList, setFeedbackList] = useState([]);
  const [loadingFeedback, setLoadingFeedback] = useState(true);
  const [feedbackError, setFeedbackError] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    setLoadingFeedback(true);
    setFeedbackError("");

    try {
      const response = await authFetch(
        `https://api-discloseai.essolutions.ai/api/v1/workspace/fetch-all-complaints-wrkspc`
      );

      if (!response.ok) {
        throw new Error("Unable to fetch feedback.");
      }

      const data = await response.json();

      setFeedbackList(Array.isArray(data) ? [...data].reverse() : []);
    } catch (err) {
      console.error(err);
      setFeedbackError("Unable to load feedback.");
    } finally {
      setLoadingFeedback(false);
    }
  };

  const copyFeedbackLink = async () => {
    await navigator.clipboard.writeText(FEEDBACK_FORM_URL);

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString([], {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="feedbackHistoryWrapper">
      <div className="feedbackHistoryHeader">

        <div>
          <h2>Feedback Management</h2>
          <p>View all submitted feedback.</p>
        </div>

        <div className="feedbackHistoryActions">

          <button
            className="feedbackCopyBtn"
            onClick={copyFeedbackLink}
          >
            {copied ? "Copied!" : "Copy Feedback Link"}
          </button>

          <button
            className="feedbackOpenBtn"
            onClick={() => window.open(FEEDBACK_FORM_URL, "_blank")}
          >
            Open Form
          </button>

        </div>
      </div>

      {loadingFeedback ? (
        <div className="feedbackLoadingState">
          Loading feedback...
        </div>
      ) : feedbackError ? (
        <div className="feedbackErrorState">
          {feedbackError}
        </div>
      ) : feedbackList.length === 0 ? (
        <div className="feedbackEmptyState">
          No feedback submitted yet.
        </div>
      ) : (
        <div className="feedbackCardsContainer">

          {feedbackList.map((item) => (

            <div
              className="feedbackHistoryCard"
              key={item.id}
            >
              <div className="feedbackCardHeader">

                <span className="feedbackTopicBadge">
                  {item.topic}
                </span>

                <span className="feedbackDate">
                  {formatDate(item.created_at)}
                </span>

              </div>

              <div className="feedbackContent">
                {item.feedback}
              </div>

              <div className="feedbackMeta">

                <div>
                  <strong>Assigned:</strong>{" "}
                  {item.assigned_to || "-"}
                </div>

                <div>
                  <strong>Status:</strong>{" "}
                  <span className={`statusBadge ${item.status.replace(/\s+/g, "")}`}>
                    {item.status}
                  </span>
                </div>

                <div>
                  <strong>Priority:</strong>{" "}
                  <span className={`priorityBadge ${item.priority}`}>
                    {item.priority}
                  </span>
                </div>

              </div>

              {item.resolved_at && (
                <div className="feedbackResolved">
                  Resolved on {formatDate(item.resolved_at)}
                </div>
              )}

            </div>

          ))}

        </div>
      )}
    </div>
  );
};

export default FeedbackPage;